// Categorias de "Regras e Versões do Sistema" (CE-3522).
// O valor gravado no banco é curto ("Regra"/"Versao"); o rótulo é o que o usuário vê.
export const CATEGORIA_REGRA = "Regra";
export const CATEGORIA_VERSAO = "Versao";

export const opcoesCategoria = [
    { value: CATEGORIA_REGRA, label: "Regra do Sistema" },
    { value: CATEGORIA_VERSAO, label: "Versão do Sistema" }
];

export const descricaoCategoria = (categoria) =>
    opcoesCategoria.find(opcao => opcao.value === categoria)?.label ?? "";

export const filtrarPorCategoria = (itens, categoria) =>
    (itens ?? []).filter(item => item.categoria === categoria);
 
// Mesmo limite de RegraVersaoSistemaService.TamanhoMaximoArquivoMB na API.
// Validar aqui evita subir o arquivo inteiro só para receber o erro no fim.
export const TAMANHO_MAXIMO_ARQUIVO_MB = 65;

export const validarArquivoPdf = (arquivo) => {
    if (!arquivo)
        return null;

    if (arquivo.type !== "application/pdf" && !arquivo.name?.toLowerCase().endsWith(".pdf"))
        return "Apenas arquivos com extensão .pdf são aceitos.";

    if (arquivo.size > TAMANHO_MAXIMO_ARQUIVO_MB * 1024 * 1024)
        return `O arquivo não pode exceder ${TAMANHO_MAXIMO_ARQUIVO_MB} MB.`;

    return null;
};

export const abrirConsultaPublica = () =>
    window.open(`${window.location.origin}/empty/regras-e-versoes-sistema`, "_blank", "noopener,noreferrer");
